import { render, staticRenderFns } from "./FeedTags.vue?vue&type=template&id=4a3a8fae&scoped=true&"
import script from "./FeedTags.vue?vue&type=script&lang=js&"
export * from "./FeedTags.vue?vue&type=script&lang=js&"
import style0 from "./FeedTags.vue?vue&type=style&index=0&id=4a3a8fae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3a8fae",
  null
  
)

export default component.exports